export const APP_VERSION = "0.20.0";
export const APP_VERSION_DATE = "2026-10-12";
export const APP_VERSION_NAME = "Two-Factor Authentication";
